import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addOnLabels: {
        /** Label for archival storage add-on */
        archivalStorage: string;
        /** Label for mounted storage add-on */
        mountedStorage: string;
        /** Label for active storage add-on */
        storage: string;
        /** Label for user/member add-on */
        member: string;
        /** Label for team seat add-on */
        teamSeat: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Add-on type labels displayed in billing and plan summaries */
            addOnLabels: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Label for archival storage add-on */
                        archivalStorage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "constants.addOnLabels.archivalStorage?c=2ah9uo36lipf8", defaultMessage: "Archival storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for mounted storage add-on */
                        mountedStorage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "constants.addOnLabels.mountedStorage?c=59m01ur7fo8c", defaultMessage: "Mounted storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for active storage add-on */
                        storage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "constants.addOnLabels.storage?c=1sao7shjzhwoe", defaultMessage: "Storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for user/member add-on */
                        member: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "constants.addOnLabels.member?c=m9y5ixy73rk5", defaultMessage: "Member" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for team seat add-on */
                        teamSeat: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "constants.addOnLabels.teamSeat?c=3u9oq1b647kk5", defaultMessage: "Team Seat" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
